import React from 'react';
import { Tag } from 'antd';
import { CheckCircleTwoTone, MinusCircleOutlined, SwapOutlined } from '@ant-design/icons';
import { getTagForAIProcessResponse } from '@src/components/Common/Tags';
import { RowStatus } from './rows';

/**
 * Where a row stands, as a tag.
 *
 * A row that has not got past the call itself is in an AI processor response
 * state, and those already have a tag everywhere else in the app — the pack
 * pipeline, the response log — so this defers to it rather than inventing a
 * second vocabulary for the same four words. Only the comparison, which the
 * response log has no notion of, is dressed here.
 */
const EvaluationStatusTag = ({ status }: { status: RowStatus }) => {
    if (status.kind === 'response' && status.state) return getTagForAIProcessResponse(status.state);

    if (status.kind === 'passed') {
        return (
            <Tag icon={<CheckCircleTwoTone twoToneColor="#52c41a" />} color="success">
                Passed
            </Tag>
        );
    }

    if (status.kind === 'mismatch') {
        // not an error: the model answered, it just did not answer this
        return (
            <Tag icon={<SwapOutlined />} color="error">
                Mismatch
            </Tag>
        );
    }

    return (
        <Tag icon={<MinusCircleOutlined />}>
            {status.text}
        </Tag>
    );
};

export default EvaluationStatusTag;
